<template>
  <Panel>
    <template slot="panel">
      <Breadcrumb :routes="routes"></Breadcrumb>
      <Title title="PRODUCTION LINE ENGINE"></Title>
      <p class="font-20">
        Digital Production Line Engine makes it easy to digitize manufacturing operations and control production
        activities to ensure manufacturing schedules and quality standards are always met. By inheriting a digital model
        from MPM, Production Line Engine can directly send accurate process parameters to the correct machine or line
        devices in real-time. Because those devices are now executable, automated event triggers can then configure and
        drive processes using time sequences defined in the MPM model.
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" /> Easily accommodate production schedule changes - balancing
        equipment, people, and materials
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
        Avoid common quality and equipment problems inherent with line changes, engineering changes, test version
        upgrades, and other scenarios.
        <p class="font-16">
          <a-icon type="caret-right" :style="iconColor" />
          Quickly redeploy operational and business logic to align with changing business needs</p>
        <p class="font-16">
          <a-icon type="caret-right" :style="iconColor" />
          Eliminate expensive hardware and integration costs</p>
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import Breadcrumb from '@/components/breadcrumb'
import Title from '@/components/title'
export default {
  components: {
    Panel,
    Breadcrumb,
    Title
  },

  data () {
    return {
      routes: [{
        name: this.$root.language.jwisoftware,
        path: '/'
      },
      {
        name: this.$root.language.products,
        path: '/products'
      },
      {
        name: this.$root.language.productionLineEngine,
        path: '/products/productionLine'
      }
      ],
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>
